import { memberCalls2Url } from '@helpers/httpHelpers'
import axios from 'axios'

function productCredit({ baId, ushopCountryCode, token }: { baId: string; ushopCountryCode: string; token: string }) {
    const url = memberCalls2Url({
        path: `/etlV2/credit/availableBalance?baId=${baId}&ushopCountryCode=${ushopCountryCode}`
    })

    return axios.get(url, {
        headers: {
            'authorization-hydra': `Bearer ${token}`
        }
    })
}

export const ProductCreditAPI = {
    productCredit
}
